import { Button, Card, Stack, Typography } from '@mui/material';
import HeadingWithDescription from '../../components/headingWithDescription';
import { Call, WhatsApp, EmailOutlined, ChatBubble } from '@mui/icons-material';
import { SECONDARY_COLOR } from '../../constants';

const ActionButton = ({
  Icon,
  title,
  link,
  iconColor,
}: {
  Icon: any;
  title: string;
  link: string;
  iconColor?: string;
}) => {
  return (
    <Button
      sx={{
        display: 'block',
        '& .MuiTypography-root': {
          textTransform: 'none', // Remove uppercase transformation
        },
      }}
      color="primary"
      onClick={() => window.open(link)}
    >
      <Stack direction={'row'} gap={1} alignItems={'center'}>
        <Icon sx={{ fontSize: 16, color: iconColor }} />
        <Typography variant="body1">{title}</Typography>
      </Stack>
    </Button>
  );
};

export default function ContactUs() {
  return (
    <Stack p={2} flex={1} bgcolor={'white'} gap={4}>
      <HeadingWithDescription heading="Support" description="We are here to help!" />
      <Stack gap={1}>
        <Card sx={{ p: 2, flexDirection: 'column' }}>
          <Typography fontWeight={500} mb={1}>
            WhatsApp
          </Typography>
          <ActionButton
            Icon={WhatsApp}
            title="919231004321"
            link="https://wa.me/919231004321"
            iconColor="green"
          />
        </Card>
        <Card sx={{ p: 2, flexDirection: 'column' }}>
          <Typography fontWeight={500} mb={1}>
            Chatbot
          </Typography>
          <ActionButton
            Icon={ChatBubble}
            title="Click to chat"
            link="https://cb.ifbsupport.com/"
            iconColor={SECONDARY_COLOR}
          />
        </Card>
        <Card sx={{ p: 2, flexDirection: 'column' }}>
          <Typography fontWeight={500} mb={1}>
            Email
          </Typography>
          <ActionButton
            Icon={EmailOutlined}
            title="customerservice@ifbglobal.com"
            link="mailto:customerservice@ifbglobal.com"
            iconColor={SECONDARY_COLOR}
          />
        </Card>
        <Card sx={{ p: 2, flexDirection: 'column' }}>
          <Typography fontWeight={500} mb={1}>
            Call
          </Typography>
          <ActionButton
            Icon={Call}
            title="080 695 45678"
            link="tel:08069545678"
            iconColor={SECONDARY_COLOR}
          />
          <ActionButton
            Icon={Call}
            title="080 458 45678"
            link="tel:08045845678"
            iconColor={SECONDARY_COLOR}
          />
        </Card>
        {/* <Card sx={{ p: 2 }}>
          <Typography fontWeight={500} mb={1}>
            Consumer Complaints
          </Typography>
          <Typography variant="body2">IFB Industries Limited</Typography>
          <Typography variant="body2">Home Appliances Division,</Typography>
          <Typography variant="body2">
            L1, Verna Electronic City, Verna
          </Typography>
          <Typography variant="body2">Salcete, GOA</Typography>
          <Typography variant="body2">India - 403722</Typography>
        </Card> */}
        <Card sx={{ p: 2 }}>
          <Typography fontWeight={500} mb={1}>
            Corporate Address
          </Typography>
          <Typography variant="body2">IFB Industries Limited</Typography>
          <Typography variant="body2">2, Plot No. IND-5, Sector-1,</Typography>
          <Typography variant="body2">East Kolkata, Kolkata,</Typography>
          <Typography variant="body2">India - 700107</Typography>
        </Card>
      </Stack>
    </Stack>
  );
}
